const Categories = {
  DGS: 'The Great Ace Attorney',
  BNHA: 'Boku no Hero Academia',
  FE14: 'Fire Emblem: Fates',
  YGOVR: 'Yu-Gi-Oh VRAINs',
  AA: 'Ace Attorney',
}

interface IFic {
  title: string
  fandom: string[]
  year: string
  ships: string
  tags: string
  summary: string
  series?: string[]
  locked?: boolean
  id?: string
}
const WORKS: IFic[] = [
  {
    title: 'Trial By Fire',
    id: '40228461',
    fandom: [Categories.DGS],
    year: '2022',
    ships: 'Minor Susato/Rei (Susato/Haori)',
    tags: 'AU, Fantasy',
    summary: 'Susato and Souseki are brought before the Ishgardian Tribunal on account of suspected heresy, and to clear their charges, they agree to a trial by combat. Ryuunosuke arriving just in time to fight for Souseki is an encouraging turn of events, but they encounter a man from another land, armed with a scythe.',
    series: ['dgs ffxiv au', '2739091'],
    locked: true,
  },
  {
    title: 'Severance',
    id: '36672775',
    fandom: [Categories.DGS],
    year: '2022',
    ships: 'Kazuma/Ryuunosuke',
    tags: 'AU, Fantasy',
    summary: 'An unfortunate run-in with a noble and a magic accident somehow lands Ryuunosuke Naruhodou in the arms of one Kazuma Asougi, who\'s convinced that Ryuunosuke is the kingdom\'s missing prince and a possible last hope to vanquish the encroaching corruption. Ryuunosuke asked for absolutely none of this.',
    series: ['dgs ffxiv au', '2739091'],
    locked: true,
  },
  {
    title: 'praise the blessed one',
    id: '37617478',
    fandom: [Categories.DGS],
    year: '2022 - Current',
    ships: 'Kazuma/Ryuunosuke',
    tags: 'AU, Fantasy',
    summary: 'An unfortunate run-in with a noble and a magic accident somehow lands Ryuunosuke Naruhodou in the arms of one Kazuma Asougi, who\'s convinced that Ryuunosuke is the kingdom\'s missing prince and a possible last hope to vanquish the encroaching corruption. Ryuunosuke asked for absolutely none of this.',
    locked: true,
  },
  {
    title: 'don’t force your excessive thoughts on me',
    id: '31391969',
    fandom: [Categories.BNHA],
    year: '2022',
    ships: 'Dabi/Hawks',
    tags: 'AU, Sci-Fi, Mecha',
    summary: 'A short story of Dabi and Hawks in a mecha anime setting. Lots of pseudo-science jargon, angsty with a happy ending. Written for DabiHawks Week 2021.',
  },
  {
    title: 'Rieducare',
    id: '17741540',
    fandom: [Categories.BNHA, 'Katekyo Hitman Reborn!'],
    year: '2020 - Current',
    ships: 'Gen',
    tags: 'Crossover',
    summary: 'A homicide shouldn\'t have gotten so much scrutiny from both the police and the Pro Hero community. But this one was an exception, because the victim wasn\'t just anyone, but a Pro Hero, and worse, one of the Vongola. And the reports of the Vongola\'s top brass flying in to Japan to address the case were not calming anyone\'s nerves.',
    series: ['Heroic Clam Squad', '1240397'],
  },
  {
    title: 'maker\'s ruin',
    id: '20422436',
    fandom: [Categories.YGOVR],
    year: '2019 - 2020',
    ships: 'Yusaku/Ryouken, Aoi/Miyu',
    tags: 'AU, Fantasy',
    summary: 'Shadowbringers AU where Yusaku is the Warrior of Light and Ryouken is the Crystal Exarch. Incomplete and discontinued.',
    locked: true,
  },
  {
    title: 'As Dark Comes the Night',
    id: '7514896',
    fandom: [Categories.FE14],
    year: '2016 - Current',
    ships: 'Custom MU/Niles, Multiple',
    tags: 'Canon Divergence, Fantasy',
    summary: '"From this day forth, we make a promise. We will be a family that doesn\'t keep secrets from each other. We will be a family that won\'t abandon each other in times of need. We will be a family that doesn\'t hurt each other. We will be a true family." A collection of ideas, discussions, and short stories to expand the universe of Fire Emblem Fates and an exploration of a slightly alternative path to Conquest.',
    series: ['I as Future Kings', '512113'],
  },
  {
    title: 'As Dark Comes the Night: The Codex',
    id: '7536472',
    fandom: [Categories.FE14],
    year: '2016 - Current',
    ships: 'Multiple',
    tags: 'AU, Fantasy, Canon Divergence',
    summary: 'A Brief history of Nohr and Hoshido as well as discussion pieces for "As Dark Comes the Night" and answered questions related to the main story.',
    series: ['I as Future Kings', '512113'],
    locked: true,
  },
  {
    title: 'Housewarming',
    id: '21766903',
    fandom: [Categories.YGOVR],
    year: '2019',
    ships: 'Yusaku/Ryouken',
    tags: 'Post-Canon, Domestic Fluff',
    summary: 'To revitalize Link Vrains\' player base, SOL introduces player housing, but they underestimated just how much of a demand housing would be. In light of the major shortage, Revolver takes drastic measures to get his hands on a plot: marrying Playmaker in Link Vrains. Written for Datastorm December 2019',
    locked: true,
  },
  {
    title: 'ga//antry',
    id: '21224537',
    fandom: [Categories.YGOVR],
    year: '2019',
    ships: 'Gen',
    tags: 'AU, Sci-Fi, Mecha',
    summary: 'If only he had an ounce of the strength the Playmaker had, Takeru thought bitterly. It didn\'t matter if that man was considered a traitor to the Alliance, any soldier would say that he was a genius of his generation, today\'s generation, actually. What a cruel twist of fate that both of them were born in the same year only to turn out as totally different people. The best Takeru could do was aspire to such an impossible ideal.',
    series: ['0xS74RDUS7', '1493597'],
    locked: true,
  },
  {
    title: 'Voice of No Return',
    id: '20949422',
    fandom: [Categories.YGOVR],
    year: '2019',
    ships: 'Gen',
    tags: 'Canon Divergence, Post-Apocalypse, Post-Canon',
    summary: 'Every waking hour was a reminder of the bleeding form that was wasted so needlessly, because the humans couldn\'t accept them, couldn\'t accept him. There was little left to tie him down to this earth, so raze it down he shall. A collection of small ficlets for an AU in continuation of the bad future Ai foresaw, and the war raged on until it lost all meaning.',
    series: ['0xS74RDUS7', '1493597'],
  },
  {
    title: 'Heaven\'s Fall',
    id: '20770100',
    fandom: [Categories.YGOVR],
    year: '2019',
    ships: 'Yusaku/Ryouken, Yusaku/Spectre, Spectre/Ryouken',
    tags: 'AU, Mecha, Sci-fi',
    summary: 'Unrelated scene inspired by the Season 1 of Aldnoah.Zero',
    series: ['0xS74RDUS7', '1493597'],
    locked: true,
  },
  {
    title: 'Banshee',
    id: '20747225',
    fandom: [Categories.YGOVR],
    year: '2019',
    ships: 'Gen',
    tags: 'AU, Mecha, Sci-fi',
    summary: 'Yusaku couldn\'t shake his friend off of him with the way he was clinging to his arms for dear life. He looked to Ai, who could only shrug. They themselves weren\'t entirely sure about this plan, and they\'d need any kind of help they could get to break through to Jin.',
    series: ['0xS74RDUS7', '1493597'],
    locked: true,
  },
  {
    title: 'Seventh Dawn',
    id: '19316032',
    fandom: [Categories.BNHA],
    year: '2019',
    ships: 'Gen',
    tags: 'AU, Fantasy',
    summary: 'Final Fantasy XIV Crossover AU. Series of oneshots and drabbles of the lovely adventures of Izuku and the rest of his adventurer friends.',
    locked: true,
  },
  {
    title: 'The Bazooka Chronicles',
    id: '17518862',
    fandom: [Categories.BNHA, 'Katekyo Hitman Reborn!'],
    year: '2019',
    ships: 'Gen',
    tags: 'AU, Crossover',
    summary: 'A series of drabbles about whoever has the misfortune to be hit by the Ten Year Bazooka, whether by sheer accident or Hatsume rummaging through the Vongola armory without permission.',
    series: ['Heroic Clam Squad', '1240397'],
    locked: true,
  },
  {
    title: 'Domanda',
    id: '17471348',
    fandom: [Categories.BNHA, 'Katekyo Hitman Reborn!'],
    year: '2019',
    ships: 'Gen',
    tags: 'AU, Crossover',
    summary: 'After coming up with almost nothing on the Vongola, Deku gets lucky and meets Sawada again at the Culture Festival.',
    series: ['Heroic Clam Squad', '1240397'],
  },
  {
    title: 'Grazioso',
    id: '17323640',
    fandom: [Categories.BNHA, 'Katekyo Hitman Reborn!'],
    year: '2019',
    ships: 'Gen',
    tags: 'AU, Crossover',
    summary: 'Deku encounters a questionable individual at Sir Nighteye\'s funeral, and the rest of the Nighteye Agency aren\'t happy about that.',
    series: ['Heroic Clam Squad', '1240397'],
  },
  {
    title: '0xF14E',
    id: '5155130',
    fandom: ['Seraph of the End'],
    year: '2015-2018',
    ships: 'Mikaela/Yuuichirou',
    tags: 'AU, Mecha, Crossover',
    summary: 'They meet again for the first time in years, in the middle of the stars. Long gone is their reason to avenge. This silly war never did them any good to begin with.',
    series: ['Elsewheres', '332155'],
    locked: true,
  },
  {
    title: 'Almagest',
    id: '4536195',
    fandom: ['Seraph of the End'],
    year: '2015',
    ships: 'Mikaela/Yuuichirou',
    tags: 'AU, Demons, Fusion',
    summary: 'Devil Survivor AU. Mika signs Yuu up for a website that delivers videos of people\'s deaths, and the two get more than what they bargained for in the form of demons. Separated by a world changing conflict, the two must find each other again.',
    series: ['Elsewheres', '332155'],
    locked: true,
  },
]

export {type IFic, Categories, WORKS}